<template>
    <div class="flex-col page">
        <div class="flex-col group_3">
            <div class="flex-col section_1">
                <div class="flex-col group_4">
                    <img src="https://imgpub1.shouqiev.com/gofunplatform/files/20220815/XblryVsvYA.png" />
                    <span class="text_3">预定成功</span>
                    <span class="text_4">{{ desc }}</span>
                </div>
                <div class="flex-col items-end button">
                    <div class="group_5">
                        <span class="text_5">您可在</span>
                        <span class="text_6">GoFun优选 - 购买记录</span>
                        <span class="text_7">查看您的订单</span>
                    </div>
                </div>
                <div class="flex-col items-center button_1" @click="goback"><span class="text_8">我知道了</span></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            desc: ""
        };
    },
    created() {
        this.desc = this.$route.query.desc
    },
    methods: {
        goback() {
            this.$router.replace({
                path: "/salePassat/orderlist"
            })
        }
    },
};
</script>

<style scoped lang="scss">
@import '../common.css';
.page {
    padding-top: 0.027rem;
    background-color: #f5f5f5;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;

    .group_3 {
        padding: 0.24rem 0 6rem;
        overflow-y: auto;

        .section_1 {
            margin: 0 0.21rem;
            padding: 0.61rem 0.32rem 0.64rem;
            background-color: #ffffff;
            border-radius: 0.21rem;

            .group_4 {
                margin-left: 0.32rem;
                margin-right: 0.53rem;
                padding: 0.67rem 0;

                img {
                    align-self: center;
                    width: 2.08rem;
                    height: 2.08rem;
                }

                .text_3 {
                    margin-top: 0.21rem;
                    align-self: center;
                    color: #333333;
                    font-size: 0.43rem;
                    font-family: 'PingFang SC';
                    font-weight: 500;
                    line-height: 0.59rem;
                }

                .text_4 {
                    margin-top: 0.11rem;
                    color: #999999;
                    font-size: 0.32rem;
                    font-family: 'PingFang SC';
                    line-height: 0.48rem;
                    text-align: justify;
                }
            }

            .button {
                margin: 0 0.32rem;
                padding: 0.21rem 0;
                background-color: #f5f5f5;
                border-radius: 0.21rem;

                .group_5 {
                    margin-right: 0.63rem;
                    line-height: 0.48rem;

                    .text_5 {
                        color: #999999;
                        font-size: 0.32rem;
                        font-family: 'PingFang SC';
                        line-height: 0.48rem;
                    }

                    .text_6 {
                        color: #02d644;
                        font-size: 0.32rem;
                        font-family: 'PingFang SC';
                        line-height: 0.48rem;
                    }

                    .text_7 {
                        color: #999999;
                        font-size: 0.32rem;
                        font-family: 'PingFang SC';
                        line-height: 0.48rem;
                    }
                }
            }

            .button_1 {
                margin-top: 1.28rem;
                padding: 0.35rem 0 0.32rem;
                background-color: #02d644;
                border-radius: 0.59rem;

                .text_8 {
                    color: #ffffff;
                    font-size: 0.43rem;
                    font-family: 'FZLanTingHeiS-DB-GB';
                    line-height: 0.51rem;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// paySucc.vue?dda57790